import { Typography } from '@mui/material';
import { Route } from 'app/enums';
import { sessionSelector } from 'app/store/session/selectors';
import capitalize from 'lodash/capitalize';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EmptyPlaceholder } from 'shared/components/EmptyPlaceholder';
import { TournamentStateFilter } from '@okletsplay/core';

interface EmptyTournamentListPlaceholderProps {
  message?: string;
}

export const EmptyTournamentListPlaceholderComponent: FC<EmptyTournamentListPlaceholderProps> = ({
  message,
}) => {
  const navigate = useNavigate();
  const tournamentFilter = useSelector(sessionSelector.tournamentFilter);

  const formattedMessage = useMemo(() => {
    if (message) {
      return message;
    }

    if (!tournamentFilter || tournamentFilter === TournamentStateFilter.All) {
      return 'No Tournaments.';
    }

    return `No ${capitalize(tournamentFilter)} Tournaments.`;
  }, [message, tournamentFilter]);

  const openModal = useCallback(() => navigate(Route.CreateTournament), [navigate]);

  return (
    <EmptyPlaceholder text={formattedMessage}>
      <Typography
        color="primary.light"
        sx={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={openModal}
      >
        Create a new tournament!
      </Typography>
    </EmptyPlaceholder>
  );
};

export const EmptyTournamentListPlaceholder = memo(EmptyTournamentListPlaceholderComponent);
